<template>
  <div class="share" v-if="notFound">
    <div class="dashboard">
    <h2 style="text-transform: uppercase;">{{ $t('records.electronicRegister') }}</h2>
     <div class="card">
      <div class="card-content">
        <p>{{ $t('records.registerNotFound') }}</p>
      </div>
     </div>
    </div>
  </div>
  <div class="share" v-else-if="loaded">
    <div class="dashboard">
    <h2 style="text-transform: uppercase;">{{ $t('records.electronicRegister') }}</h2>

     <div class="card">
      <div class="card-title">
        <h2>{{ $t('records.receiver') }}</h2>
      </div>

      <div class="card-content">
        <h4>{{ this.receiver }}</h4>
        <br />
        <p><strong>{{ $t('records.registerName') }}</strong></p>
        <p>{{ this.file.name }}</p>
        <p><strong>{{ $t('records.registerDescription') }}</strong></p>
        <p>{{ this.file.message }}</p>
      </div>
     </div>

     <div class="card">
      <div class="card-content">
        <p>{{ $t('records.registerGenericInfo') }}</p>
      </div>

    <div class="card-action">
      <button @click="submit" id ="buttonStart"
        class="button button--flat"
        type="submit"
        >{{ $t('records.start') }}</button>
    </div>

     </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'share',
  data: () => ({
    loaded: false,
    notFound: false,
    file: null,
    progress: 0,
    receiver: ''
  }),
  watch: {
    '$route': 'fetchData'
  },
  created: function () {
      let thisComponent = this;
      let JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
      onActionProgress: function(action)
      {
          if (action.type != Module.ActionType.DOWNLOAD.value
            && action.type != Module.ActionType.DOWNLOAD_ZIP.value) {
            return;
          }

          thisComponent.progress = action.size ? action.completed * 100 / action.size : 0;
      }
    });

    this.interfaceObject = new JavaEventListenerClass();
    ibb.addActionListener(this.interfaceObject);

    this.fetchData();
  },
  beforeDestroy () {
    ibb.removeActionListener(this.interfaceObject);
  },
  computed: {
    link: function () {
      return document.location.href;
    },
    fullLink: function () {
      return document.location.href;
    }
  },
  methods: {
    fetchData: async function () {
      try {
        let action = await ibbLink.getInboxInfo(this.link);
        if (action.error.type) {
          this.notFound = true;
          return;
        }

        this.file = action.node;
        this.receiver = action.name;
        this.loaded = true;
      } catch (e) {
        this.notFound = true;
        return;
      }
    },
    submit: async function () {
      let link = document.location.href;
      let action = await ibbLink.startRecord(link);
      if (action.error.type) {
        throw new Error('Error starting record: ' +  action.error.type);
      }

      let newRecordLink = action.session;
      this.$router.push({ path: newRecordLink.substring(19) });
    }
  }
};
</script>
